const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

export const fetchRefreshCache = async (cacheName, strategyCode = null) => {
  try {
    const url = strategyCode
      ? `${BASE_URL}/refreshCache/${cacheName}/${strategyCode}`
      : `${BASE_URL}/refreshCache/${cacheName}`;
    
    const response = await fetch(url, {
      method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.text(); // Use .text() since the backend returns a string response
    return data;
  } catch (error) {
    console.error('Error refreshing cache:', error);
    throw error;
  }
};
